<h3>Users

	<a routerLink="/manageUsersAdd" >
		<img title="Add user" src="assets/images/AddIcon/Button_Add_Icon_32.png" class="addButton" style="float:right" width="38" height="38">	
	</a>

</h3>

<div>
							
<!-- users table -->
<p-table #dt [value]="users" [columns]="cols" > 
	<!-- search filter -->
	<ng-template pTemplate="caption">
		<div style="text-align: right">
			<i class="fa fa-search" style="margin:4px 4px 0 0"></i>
			<input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
		</div>
	</ng-template>

	<ng-template pTemplate="colgroup">
		<colgroup>
			<col>
			<col>
			<col>
			<col>
			<col style="width:40px"> <!-- edit button -->
			<col style="width:40px"> <!-- delete button -->
		</colgroup>
	</ng-template>

	<ng-template pTemplate="header" let-columns>
		<tr>
			<th *ngFor="let col of columns">
				{{col.header}}
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-rowData>
		<tr>
			<!-- user name -->
			<td>{{rowData.username}}</td>
			<!-- name -->
			<td>{{rowData.name}}</td>
			<!-- email -->
			<td>{{rowData.email}}</td>
			<!-- roles -->
			<td>{{rowData.rolesString}}</td>
			<!-- delete column -->
			<td [style]="{'width':'40px'}"><a routerLink="/manageUsersAdd/{{rowData.username}}" >
				<img title="Edit user" [src]="editButtonPath" class="editUserButton"> 
				<!-- <img title="Edit user" src="assets/images/EditIcon/Edit_Icon_32.png" class="editUserButton">  -->
				</a>
			</td>
			<td [style]="{'width':'40px'}"><input type="button" class="userActionButton deleteUserButton" (click)="deleteUser(rowData.username)" title="Delete this user" /></td>
		</tr>
	</ng-template>
</p-table>
</div>

<!-- Growl Module has been deprecated
<p-growl [value]="msgs"></p-growl>
-->
<p-confirmDialog width="425"></p-confirmDialog>
<!-- this was an effort to change the icon to a trash can for "Yes" but need to come back to get it working
<p-confirmDialog header="Confirmation" icon="fa fa-question-circle" width="425" #cd>
    <p-footer>
        <button type="button" pButton icon="fa-close" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="fa-trash" label="Yes" (click)="cd.accept()"></button>
    </p-footer>
</p-confirmDialog>
-->